import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';

@Injectable({
  providedIn: 'root'
})
export class AdditionalPublicLibraryService {

  constructor(
    private apiService: ApiService
  ) { }

  loadCategories() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USER_OUTLETS_CATEGORIES);
  }

  createAdditionalPublicLibrary(param) {
    const formData = new FormData();
    Object.entries(param).forEach(([key, value]) => {

      if (key !== 'user_outlet_location_attributes') {
        formData.set(`user_outlet[${key}]`, value as string);
      } else {
        Object.entries(param['user_outlet_location_attributes']).forEach(([k, v]) => {
          if (v)
            formData.set(`user_outlet[${key}]${k}`, v.toString() as string);
          else if (k == 'id')
            formData.set(`user_outlet[${key}]${k}`, v as string);
        });
      }
    });



    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USER_OUTLETS, formData);
  }

  editAdditionalPublicLibrary(param, userId) {
    const formData = new FormData();
    Object.entries(param).forEach(([key, value]) => {

      if (key !== 'user_outlet_location_attributes') {
        formData.set(`user_outlet[${key}]`, value as string);
      } else {
        Object.entries(param['user_outlet_location_attributes']).forEach(([k, v]) => {
          if (v)
            formData.set(`user_outlet[${key}]${k}`, v.toString() as string);
          else if (k == 'id')
            formData.set(`user_outlet[${key}]${k}`, v as string);
        });
      }
    });
    return this.apiService.put(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USER_OUTLETS + '/' + userId, formData);
  }

  getAdditionalPublicLibrary() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USER_OUTLETS
    );
  }

  getOutletContents(id) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USER_OUTLETS + '/' + id + API_ENDPOINTS.API.OUTLET_CONTENTS
    );
  }
  getAdditionalPublicLibraryById(id) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USER_OUTLETS + '/' + id
    );
  }

  deleteAdditionalPublicLibrary(userId) {
    return this.apiService.delete(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USER_OUTLETS + '/' + userId);
  }

  getAdditionalPublicLibrarySettings(userId) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USER_OUTLETS + '/' + userId + API_ENDPOINTS.API.GET_SETTINGS);
  }

  updateAdditionalPublicLibrarySettings(userId, params) {
    return this.apiService.put(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USER_OUTLETS + '/' + userId + API_ENDPOINTS.API.UPDATE_SETTINGS, params);
  }

  getTimeMatrices() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.TIME_MATRIX);
  }

  generateQRcode(userId, params) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USER_OUTLETS + '/' + userId + API_ENDPOINTS.API.QR_CODE, params);
  }

  listQRcode(userId) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USER_OUTLETS + '/' + userId + API_ENDPOINTS.API.QR_CODE);
  }

  deleteQRcode(userId, params) {
    return this.apiService.patch(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USER_OUTLETS + '/' + userId + API_ENDPOINTS.API.QR_CODE + '/update_records', params);
  }

  listIndividualOutlets() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.OUTLETS_INDIVIDUAL_CUSTOMER + API_ENDPOINTS.API.FETCH_USER_ADDITIONAL_PUBLIC_LIBRARY);
  }
  assignContentToOutlet(data) {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formData.set(`${key}`, value as string);
    });
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.OUTLETS_INDIVIDUAL_CUSTOMER + API_ENDPOINTS.API.ASSIGN_CONTENT_TO_SPECIFIC_OUTLET, formData);
  }

  subscribeOutletSubscription(id) {
    const formData = new FormData();
    formData.set('outlet_id', id as string);

    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.OUTLET_SUBSCRIBERS, formData);

  }

  getOutletSubscription(id) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.OUTLET_SUBSCRIBERS + '/get_outlet_subscriber?outlet_id=' + id);
  }

  updateSubscription(status, id) {
    const formData = new FormData();
    formData.set('outlet_subscriber[status]', status as string);
    return this.apiService.patch(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.OUTLET_SUBSCRIBERS + '/' + id, formData);
  }
}
